import {VnaPbxConfigCreated} from './VnaPbxConfigCreated';

export class VnaPbxConfigRemoved extends VnaPbxConfigCreated{

}


// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna-campaign/model/VnaPbxConfigRemoved.ts